interface EmployeeInfo {
  employee_id?: string;
  name?: string;
  email?: string;
  designation?: string;
  department?: string;
}

interface ExpenseList {
  id?: number;
  member_id?: number;
  business_member_id?: number;
  amount?: number;
  remarks?: string;
  comment?: string | null;
  is_updated_by_super_admin?: number;
  closed_at?: string | null;
  type?: string;
  status?: string;
  created_by?: number;
  created_by_name?: string;
  updated_by?: number;
  updated_by_name?: string;
  created_at?: string;
  updated_at?: string;
}

const ExpenseDetailsPDF = ({
  employeeInfo,
  expenseList,
}: {
  employeeInfo: EmployeeInfo;
  expenseList: ExpenseList[];
}) => {
  return (
    <div className="p-10 text-gray-900">
      {/* Header */}
      <div className="flex justify-between items-center border-b pb-4">
        <img
          src="/images/Sheba-Business-Logo.svg"
          alt="logo"
          className="w-24"
        />
        <h3 className="text-xl font-normal text-right">Fleet Fun Sheba</h3>
      </div>

      {/* Employee Expense Section */}
      <h1 className="text-2xl font-normal mt-6">Employee Expense</h1>

      <div className="grid grid-cols-2 gap-6 mt-4">
        {/* Employee Details */}
        <div>
          <table className="w-full text-left border-collapse">
            <tbody>
              <tr>
                <td className="py-1">Employee Name</td>
                <td className="py-1 font-semibold">
                  : {employeeInfo.name || "n/a"}
                </td>
              </tr>
              <tr>
                <td className="py-1">Designation</td>
                <td className="py-1">: {employeeInfo.designation || "n/a"}</td>
              </tr>
              <tr>
                <td className="py-1">Department</td>
                <td className="py-1">: {employeeInfo.department || "n/a"}</td>
              </tr>
              <tr>
                <td className="py-1">Email</td>
                <td className="py-1">: {employeeInfo.email || "n/a"}</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Office Use Only */}
        <div>
          <table className="w-full border">
            <thead>
              <tr>
                <th colSpan={2} className="text-center border-b py-1">
                  Office Use Only
                </th>
              </tr>
            </thead>
            <tbody>
              {["Conveyance", "Holiday", "Food", "Expense Claim", "Total"].map(
                (item) => (
                  <tr key={item}>
                    <td className="py-1 px-2 border">{item}</td>
                    <td className="py-1 px-2 border"></td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Amount Section */}
      <div className="grid grid-cols-2 gap-6 mt-12">
        <div>
          <table className="w-full">
            <tbody>
              <tr>
                <td className="py-1">Amount Requested</td>
                <td className="py-1 font-semibold">: 210.00</td>
              </tr>
              <tr>
                <td className="py-1">Month</td>
                <td className="py-1">: February, 2025</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <table className="w-full">
            <tbody>
              <tr>
                <td className="py-1">In Words</td>
                <td className="py-1">: Two Hundred Ten</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <table className="w-full border mt-12">
        <thead>
          <tr>
            {["Date", "Type", "Remarks", "Amount"].map((header) => (
              <th key={header} className="border py-2 text-left px-4">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {expenseList.map((expense, index) => (
            <tr key={index}>
              <td className="border py-2 px-4">
                {expense.created_at
                  ? new Date(expense.created_at).toLocaleString()
                  : "N/A"}
              </td>
              <td className="border py-2 px-4">{expense.type || "N/A"}</td>
              <td className="border py-2 px-4">{expense.remarks || "N/A"}</td>
              <td className="border py-2 px-4 text-right">
                {expense.amount ? expense.amount.toFixed(2) : "0.00"}
              </td>
            </tr>
          ))}
          <tr>
            <td
              colSpan={3}
              className="border py-2 text-right px-4 font-semibold"
            >
              Sum
            </td>
            <td className="border py-2 px-4 text-right font-semibold">
              {expenseList
                .reduce((sum, expense) => sum + (expense.amount || 0), 0)
                .toFixed(2)}
            </td>
          </tr>
        </tbody>
      </table>

      {/* Footer Signatures */}
      <div className="grid grid-cols-4 text-center mt-20">
        {[
          "Requested by (Applicant)",
          "Checked by (Supervisor)",
          "Recommended by (HOD)",
          "Approved by (HR)",
        ].map((text) => (
          <div key={text}>
            <h6 className="font-semibold">{text.split(" ")[0]}</h6>
            <p className="text-sm">{text.split(" ")[2]}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExpenseDetailsPDF;
